import {Component, OnInit} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {ColDef, ColGroupDef, GridOptions} from "ag-grid-community";
import {ExtendedStorage} from "../../../shared/common-components/common-structure";
import {AsyncPipe, formatDate, NgIf} from "@angular/common";
import {BehaviorSubject} from "rxjs";
import {XTOSReportingService} from "../../../services/XTOS-reporting/xtos-reporting.service";
import AppConstants from 'src/app/shared/common-components/AppConstants';

@Component({
    selector: 'app-tsp-xtos-comprehensive-report',
    imports: [
        AgGridAngular
    ],
    templateUrl: './tsp-xtos-comprehensive-report.component.html',
    styleUrl: './tsp-xtos-comprehensive-report.component.css'
})
export class TspXtosComprehensiveReportComponent implements OnInit{
  xtosShipmentDetailGridOptions: GridOptions = this.initializeGridOptions();
  isXTOSShipmentSelected = false;
  format = 'MM/dd/yyyy';
  locale = 'en-US';
  private selectedExtendedStorage = new BehaviorSubject<ExtendedStorage>(null);
  selectedExtendedStorage$ = this.selectedExtendedStorage.asObservable();
  xtosShipmentDetailVM$ = this.xtosReportingService.xtosShipmentDetailData$;
  xtosComprehensiveReport:any[];
  constructor(private xtosReportingService: XTOSReportingService) {
  }

  ngOnInit() {
    this.loadTSPXtosShipmentReports();
  }

  loadTSPXtosShipmentReports(){
    // getXTOSShipmentList
    this.xtosReportingService.getXTOSShipmentList(1).subscribe(params => {
      this.xtosComprehensiveReport = params;
    
    }, error => {
      console.log('ERROR while getting XTOS Report for TSP');
    }
  );
  }

  getXTOSShipmentDetailsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      // {
      //   headerName: 'SCAC Code',
      //   field: 'scac',
      //   filter: 'agTextColumnFilter',
      //   sortable: true
      // },
      {
        headerName: 'TSP Name',
        field: 'scacName',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Shipment Report Contact Email',
        valueGetter: (params) => {
          return (params.data.email) ?
                    (params.data.email) : 'Not Available';
        },
        filter: 'agTextColumnFilter', sortable: true
      },
      {
        headerName: 'FAIC',
        field: 'faicCode',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'SRO Code',
        field: 'sroCode',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Point of Contact Email',
        valueGetter: (params: any) => {
          return (params.data.email) ?
                    (params.data.email) : 'Not Available';
        },
        filter: 'agTextColumnFilter', sortable: true
      },
      {
        headerName: 'Agency Name',
        field: 'agencyName',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Bureau Name',
        field: 'agencyBureauName',
        filter: 'agTextColumnFilter', sortable: true
      },
      {
        headerName: 'Reference Number/Pro Bill Number',
        field: 'proBillNumber',
        filter: 'agTextColumnFilter',
        sortable: true
      },

      {
        headerName: 'Bill of Lading Number',
        field: 'bolNumber',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Move Type',
        field: 'moveType',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Storage Type',
        field: 'transportationType',
        filter: 'agTextColumnFilter', sortable: true
      },
      {
        headerName: 'Pickup Date',
        cellRenderer: (params) => {
          return params.data.pickupDate ? (formatDate(params.data.pickupDate , this.format, this.locale)) : 'Not Available';
        },
        filter: 'agTextColumnFilter', sortable: true
      },
      {
        headerName: 'Date into Extended Storage',
        cellRenderer: (params) => {
          return params.data.deliveryDate ? (formatDate(params.data.deliveryDate , this.format, this.locale)) : 'Not Available';
        },
        filter: 'agTextColumnFilter', sortable: true
      },
      {
        headerName: 'Billing Date',
        cellRenderer: (params) => {
          return params.data.billingDate ? (formatDate(params.data.billingDate , this.format, this.locale)) : 'Not Available';
        },
        filter: 'agTextColumnFilter', sortable: true
      },
      {
        headerName: 'Storage Location',
        field: 'storageLoc',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Storage Zip',
        field: 'storageZip',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Storage Address',
        field: 'storageAddr',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Point of Contact',
        valueGetter: params => {
          return params.data.pofContact ? params.data.pofContact : 'Not Available';
        },
        filter: 'agTextColumnFilter', sortable: true
      },
      


      {
        headerName: 'Weight',
        field: 'weight',
        filter: 'agTextColumnFilter',
        sortable: true
      },

      // {
      //   headerName: 'Miles',
      //   field: 'miles',
      //   width: 100,
      //   filter: 'agTextColumnFilter', sortable: true
      // },


      {
        headerName: 'Total Amount Invoiced',
        field: 'amountInvoiced',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Pass Thru Amt',
        field: 'passThruAmount',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Total AF',
        field: 'totalIFF',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Reporting Year',
        field: 'reportingYear',
        filter: 'agTextColumnFilter', sortable: true
      },
      {
        headerName: 'Reporting Quarter',
        field: 'reportingQuarter',
        filter: 'agTextColumnFilter', sortable: true
      },
      {
        headerName: 'Employee Email Identifier',
        field: 'employeeEmail',
        filter: 'agTextColumnFilter', sortable: true
      },
      {
        headerName: 'Employee Last Name',
        field: 'employeeLastName',
        filter: 'agTextColumnFilter', sortable: true
      }
    ];
  }

  currencyFormatter(currency, sign) {
    if(currency === null || currency.length === 0) return '';
    var sansDec = Number(currency).toFixed(2);
    var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return sign + `${formatted}`;
  }

  private initializeGridOptions() {
    return <GridOptions>{
      columnDefs: this.getXTOSShipmentDetailsColumnDefs(),
      rowSelection: 'single',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: false
        }
      },
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      headerHeight: 50,
      domLayout: 'autoHeight',
      suppressDragLeaveHidesColumns: true,
      onGridReady: params => {
        params.api.sizeColumnsToFit();
      },
      onRowDataChanged: event => {
        this.isXTOSShipmentSelected = false;
      },
      onSelectionChanged: event => {
        this.isXTOSShipmentSelected = true;
        this.selectedExtendedStorage.next({...new ExtendedStorage(), ...event.api.getSelectedRows()[0]});
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

}
